import { Button, Dialog, Icons, Intent, Size } from "construct-ui";
import 'CssFolder/schedule/schedule-details.scss';
import _ from "lodash";
import moment from "moment";
import UserBadgeComponent from "../../../components/common/user-badge.component";
import { formats as FORMATS } from '../../../config/constants';
import teamScheduleModel, { workType } from "../../../models/schedule/team-schedule.model";
import ViewBase from "../../view-base.view";
import AssignScheduleView from "./assign-schedule.view";
import ModifyScheduleView from "./modify-schedule.view";

export default function ScheduleDetailsView() {

  ViewBase.call(this);

  let scheduleUserDetails;
  let visitRateDetails;
  let scheduleDetails;
  let showAssignModal = false;
  let showModifyModal = false;
  let needRefresh = false;
  // let isSendToJPO = false;
  let needRefreshParent = false;
  let selectedScheduleData;
  let actionType = 0; // 0 - No Action | 1 - Change | 2 - Cancel
  let userScheduleAccess = {}

  let triggerRefresh = (needRefreshParent) => { }
  let setSendToJPO = () => { }

  let loadScheduleDetails = (userId, scheduleDate) => {
    this.showLoading();

    // console.log('loadScheduleDetails ---------------- ' + userId + " | " + scheduleDate);

    // Get summary
    teamScheduleModel.getScheduleVisitSummary(
      (result) => {
        // console.log("getScheduleVisitSummary - result:", JSON.parse(JSON.stringify(result)));
        visitRateDetails = result;
      },
      (error) => {
        console.error("getScheduleVisitSummary - error:", error);
      },
      {
        fromDate: moment(scheduleDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat),
        toDate: moment(scheduleDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat),
        UserIds: userId,
      }
    );

    // Get Detailed Schedule & Non-Approved Schedule
    teamScheduleModel.getScheduleDetails(
      (result) => {
        // console.log("getScheduleDetails - result:", JSON.parse(JSON.stringify(result)));
        scheduleDetails = result;
        if (result.userScheduleAccess && result.userScheduleAccess.length > 0) {
          userScheduleAccess = result.userScheduleAccess[0];
        }
        this.hideLoading();
      },
      (error) => {
        this.hideLoading();
        console.error("getScheduleDetails - error:", error);
      },
      {
        fromDate: moment(scheduleDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat),
        userId: userId,
      }
    );
  }

  let showAssignScheduleModal = () => {
    showAssignModal = true;
  }

  let showChangeScheduleModal = (_scheduleData) => {
    showModifyModal = true;
    actionType = 1;
    selectedScheduleData = _scheduleData;
  }

  let showCancelScheduleModal = (_scheduleData) => {
    showModifyModal = true;
    actionType = 2;
    selectedScheduleData = _scheduleData;
  }

  let isTodayOrFutureDate = (momentDate) => {
    let today = moment(moment().format(FORMATS.apiDateFormat)); // without time
    if (moment(momentDate).isValid()) {
      return momentDate.diff(today, 'day') >= 0;
    } else {
      return false;
    }
  }

  // DetailedScheduleItem Component
  const DetailedScheduleItem = {
    oninit: (vnode) => {
    },
    onupdate: (vnode) => {
    },
    view: (vnode) => {
      return m('.detailed-schedule-item.d-flex.flex-nowrap.w-100',
        m('.schedule-type-container', [
          vnode.attrs.isApproved
            ? m('.schedule-type', vnode.attrs.scheduleData.scheduleTypeName)
            : m('.schedule-type', vnode.attrs.scheduleData.scheduleApprovalTypeName),
        ]),
        m('.schedule-content.card',
          m('.card-body',
            vnode.attrs.isApproved && [
              m('.d-flex.schedule-detail',
                m('label.flex-grow-0', this.getText("LT00000213", "Check In/Out")),
                m('.flex-grow-1',
                  this.getText("LT00000214", "In") + ': ',
                  _.isEmpty(vnode.attrs.scheduleData.checkInTime)
                    ? '-'
                    : m('span.text-checkin', vnode.attrs.scheduleData.checkInTime),
                  m('span.mx-2', '~'),
                  this.getText("LT00000215", "Out") + ': ',
                  _.isEmpty(vnode.attrs.scheduleData.checkOutTime)
                    ? '-'
                    : m('span.text-checkout', vnode.attrs.scheduleData.checkOutTime),
                ),

                m('.buttons-wrapper.d-flex.flex-grow-0',
                  userScheduleAccess.allowEdit && m('button[type="button"].btn.btn-link.p-0', {
                    onclick: e => showChangeScheduleModal(vnode.attrs.scheduleData)
                  },
                    m('i.bi-pencil-square.m-0')
                  ),
                  userScheduleAccess.allowDelete && m('button[type="button"].btn.btn-link.p-0.text-danger', {
                    onclick: e => showCancelScheduleModal(vnode.attrs.scheduleData)
                  },
                    m('i.bi-dash-circle.m-0')),
                ),
              ),
              m('hr'),
            ],
            m('.d-flex.schedule-detail',
              m('label', this.getText("LT00000153", "Schedule")),
              m('div',
                m('.work-type-indicator', {
                  style: {
                    'border-color': workType.getColor(vnode.attrs.scheduleData.workType),
                    'background-color': workType.getColor(vnode.attrs.scheduleData.workType),
                  }
                }),
                m('span.text-primary', vnode.attrs.scheduleData.workTypeName),
                ' | ',
                vnode.attrs.scheduleData.startTime
                  ? [vnode.attrs.scheduleData.startTime, ' ~ ', vnode.attrs.scheduleData.endTime]
                  : vnode.attrs.scheduleData.scheduleDateFormat, // YYYY.MM.DD
                (vnode.attrs.scheduleData.createUserId === "JPO" && ' | JPO' ),
                (vnode.attrs.scheduleData.createUserId === "JPOM" && ' | JPOM'),
              )
            ),
            (vnode.attrs.scheduleData.workType == "002" || vnode.attrs.scheduleData.workType == "003" || vnode.attrs.scheduleData.workType == "007")
            && m('.d-flex.schedule-detail',
              m('label', this.getText("LT00000367", "Sub-category")),
              m('div', vnode.attrs.scheduleData.leaveDayOffTypeName)
            ),
            vnode.attrs.scheduleData.workType == "001"
            && [
              m('.d-flex.schedule-detail',
                m('label', this.getText("LT00001341", "Store Name")),
                m('div', vnode.attrs.scheduleData.siteName)
              ),
              // m('.d-flex.schedule-detail',
              //   m('label', this.getText("LT00000216", "Address")),
              //   m('div', vnode.attrs.scheduleData.address)
              // ),
            ],
            vnode.attrs.scheduleData.workType != "001"
            && m('.d-flex.schedule-detail',
              m('label', this.getText("LT00000152", "Remarks")),
              m('div', vnode.attrs.scheduleData.remarks)
            ),
          )
        )
      )
    }
  }

  return {
    oninit: function (vnode) {
      if (vnode.attrs.triggerRefresh) {
        triggerRefresh = vnode.attrs.triggerRefresh;
      }
      if (vnode.attrs.setSendToJPO) {
        setSendToJPO = vnode.attrs.setSendToJPO;
      }
      scheduleUserDetails = vnode.attrs.scheduleUserDetails;
      loadScheduleDetails(scheduleUserDetails.userId, scheduleUserDetails.scheduleDates[0]);
    },
    oncreate: (vnode) => {
    },
    onupdate: (vnode) => {
      if (needRefresh) {
        needRefresh = false;
        loadScheduleDetails(scheduleUserDetails.userId, scheduleUserDetails.scheduleDates[0]);
      }
    },
    onremove: () => {
      // console.log('needRefreshParent============>', needRefreshParent)
      // console.log('needRefreshParent  onremove============>', isSendToJPO)

      triggerRefresh(needRefreshParent);
    },
    view: (vnode) => {
      return [
        m('.container-lg',
          m('.card.mb-3',
            m('.card-header.p-4',
              m('.d-flex.flex-column',
                // User profile
                scheduleUserDetails &&
                m(UserBadgeComponent, {
                  image: scheduleUserDetails.photoString,
                }, [
                  m('.user-text-lg', scheduleUserDetails.userName),
                  m('.user-text-sm', moment(scheduleUserDetails.scheduleDates[0], FORMATS.dateFormat).format('D MMMM YYYY')),
                ]
                ),
                // Visit Rate Summary
                visitRateDetails &&
                m('.schedule-visit-rate.d-flex.flex-nowrap.mt-4.mb-3',
                  m('.vr-group-data',
                    m('.vr-data.vr-data-primary',
                      m('.vr-label', this.getText("LT00000046", "Total")),
                      m('.vr-value', _.padStart(visitRateDetails.totalVisitPlan, 2, '0')),
                    )
                  ),
                  m('.vr-group-data',
                    m('.vr-data.vr-data-primary',
                      m('.vr-label', this.getText("LT00000176", "Planned")),
                      m('.vr-value', _.padStart(visitRateDetails.plannedVisit, 2, '0')),
                    ),
                    m('.vr-data.vr-data-secondary',
                      m('.vr-label', this.getText("LT00000177", "Completed")),
                      m('.vr-value', _.padStart(visitRateDetails.completedVisit, 2, '0')),
                    ),
                    m('.vr-data.vr-data-secondary.vr-text-yellow',
                      m('.vr-label', this.getText("LT00000178", "In Progress")),
                      m('.vr-value', _.padStart(visitRateDetails.inProgressVisit, 2, '0')),
                    ),
                    m('.vr-data.vr-data-secondary.vr-text-red',
                      m('.vr-label', this.getText("LT00000179", "Not Visited")),
                      m('.vr-value', _.padStart(visitRateDetails.notVisited, 2, '0')),
                    ),
                  ),
                  m('.vr-group-data',
                    m('.vr-data.vr-data-primary',
                      m('.vr-label', this.getText("LT00000180", "Unplanned")),
                      m('.vr-value', _.padStart(visitRateDetails.unplannedVisit, 2, '0')),
                    )
                  ),
                ),
              ),
            ),
            m('.card-body.p-4',
              m('.d-flex.justify-content-between.mt-3.mb-4',
                m('h2.secondary-title.mb-2', this.getText("LT00000217", "Detailed Schedule")),
                isTodayOrFutureDate(moment(scheduleUserDetails.scheduleDates[0], FORMATS.dateFormat)) && userScheduleAccess.allowAdd &&
                m(Button, {
                  intent: Intent.PRIMARY,
                  iconLeft: Icons.PLUS,
                  outlined: true,
                  size: Size.XS,
                  onclick: showAssignScheduleModal,
                })
              ),
              scheduleDetails &&
              scheduleDetails.approvedSchedule.map(scheduleItem =>
                m(DetailedScheduleItem, { isApproved: true, scheduleData: scheduleItem }),
              ),
              !(scheduleDetails && scheduleDetails.approvedSchedule.length > 0) &&
              m('.alert.alert-dark', this.getText("LT00000211", "No records"))
            ),
          ),
          m('.card',
            m('.card-body.p-4',
              m('.d-flex.justify-content-between',
                m('h2.secondary-title.mb-2', this.getText("LT00000212", "Non-Approved Schedule")),
              ),
              scheduleDetails &&
              scheduleDetails.nonApprovedSchedule.map(scheduleItem =>
                m(DetailedScheduleItem, { scheduleData: scheduleItem }),
              ),
              !(scheduleDetails && scheduleDetails.nonApprovedSchedule.length > 0) &&
              m('.alert.alert-dark', this.getText("LT00000211", "No records"))
            )
          )
        ),
        m(Dialog, {
          closeOnOutsideClick: false,
          isOpen: showAssignModal,
          style: { width: "552px", margin: 'auto' },
          onClose: (e) => { showAssignModal = false; },
          title: this.getText("LT00000153", "Schedule") + ' - ' + this.getText("LT00000210", "Assign Schedule"),
          content: m(AssignScheduleView, {
            scheduleUserDetails: scheduleUserDetails,
            onClose: (o) => { showAssignModal = o; },
            triggerRefresh: (r, j) => {
              setSendToJPO(j);
              // isSendToJPO = j;
              needRefresh = r; needRefreshParent = needRefreshParent ? needRefreshParent : r
            },
          }),
        }),
        m(Dialog, {
          class: 'modal-body-overflow-visible',
          closeOnOutsideClick: false,
          isOpen: showModifyModal,
          onClose: (e) => { showModifyModal = false; },
          title: actionType === 1 ? this.getText("LT00000153", "Schedule") + ' - ' + this.getText("LT00000209", "Change Schedule") : actionType === 2 ? this.getText("LT00000153", "Schedule") + ' - ' + this.getText("LT00000208", "Cancel Schedule") : '',
          content: m(ModifyScheduleView, {
            actionType: actionType, // 1 - Change | 2 - Cancel
            scheduleUserDetails: scheduleUserDetails,
            scheduleData: selectedScheduleData,
            onClose: (o) => { showModifyModal = o; },
            triggerRefresh: (r, j) => {
              setSendToJPO(j);
              // isSendToJPO = j;
              needRefresh = r; needRefreshParent = needRefreshParent ? needRefreshParent : r
            },
          }),
        }),
        this.getBaseViews()
      ]
    }
  }

}